import React from "react";

const Kotlin_Strings = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Kotlin Strings</h1>
      <p>Content for Kotlin Strings goes here.</p>
    </div>
  );
};

export default Kotlin_Strings;
